module.exports = __webpack_public_path__ + "static/media/know-more-header.cdea1a16.png";